export const singleton = {
    selecting: false,
    selectionAnchor: null,
    selectionAnchorType: null,
    selectionFocus: null,
    dragging: false
};
